<template>
	<div class="d-flex align-items-center m-t-10 m-b-20">
        <div class="m-r-10 ">
            <i class="icon-Cloud-Sun display-5"></i>
        </div>
        <div class="">
            <h1 class="m-b-0 font-light">
            	{{grados}}
                <sup>o</sup>
            </h1>
            <h5 class="font-light">{{ciudad.nomciudad}}</h5>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
	export default {
		data(){
			return {
				grados:0,
				ciudad:{
					nomciudad:'',
					latitude:null,
					longitude:null
				},
			}
		},
		methods:{
			Consultar_Ciudad(){
				if (this.usuario.cve_empleado!=undefined && this.cia.apikey_clima!=null) {
					this.$http.get('ciudades/empleado/'+this.usuario.cve_empleado)
					.then(respuesta=>{return respuesta.json()})
					.then(respuestaJson=>{
						if (respuestaJson.length>0) {
							this.ciudad = respuestaJson[0];
							this.Consultar_Clima();
						}else{
							this.grados=0;
							this.ciudad={
								nomciudad:'',
								latitude:null,
								longitude:null
							}
						}
					})
					.catch(error=>{
						this.grados=0;
						this.ciudad={
							nomciudad:'',
							latitude:null,
							longitude:null
						}
					});
				}
			},
			Consultar_Clima(){
				var that = this;
				var client = new HttpClient();
		        client.get('//api.openweathermap.org/data/2.5/weather?lat='+this.ciudad.latitude+'&lon='+this.ciudad.longitude+'&appid='+this.cia.apikey_clima, function(response) {
		          var respuestaJson=JSON.parse(response);
		          var vars = respuestaJson.main;
		          var temp_c = vars.temp - 273.15;
		          var temp_f = 1.8 * (vars.temp - 273.15) + 32;
		          that.grados=parseInt(temp_c);
		        });
			}
		},
		created(){
			this.Consultar_Ciudad();
		},
		watch:{
			usuario:function(){
				this.Consultar_Ciudad();
			},
			'cia.apikey_clima':function(){
				this.Consultar_Ciudad();
			}
		},
		computed:{
		  cia(){
		    return this.$store.getters.getCia;
		  },
		  usuario(){
		    return this.$store.getters.getUsuario;
		  }
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Clima/Clima.vue